module.exports = __webpack_public_path__ + "media/images/waymarker-bc3a3267ee2ddd082ac4bd3817afaf32.png";